// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__FJlaq","form":"styles_form__1rfY7"};